export * from './ActorFunctionFactoryTermPredicate';
